import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermisoSeccion } from '../models/user.model';
import { AuthService } from '../services/auth.service';

export type PermissionAction = 'view' | 'edit' | 'delete' | 'admin';

export interface RoutePermission {
  action: PermissionAction;
  seccion?: PermisoSeccion;
}

export function hasRoutePermission(
  authService: AuthService,
  permission: RoutePermission,
): boolean {
  switch (permission.action) {
    case 'admin':
      return authService.canAccessOpcionesAdmin();
    case 'view':
      return permission.seccion !== undefined && authService.canView(permission.seccion);
    case 'edit':
      return permission.seccion !== undefined && authService.canEdit(permission.seccion);
    case 'delete':
      return permission.seccion !== undefined && authService.canDelete(permission.seccion);
    default:
      return false;
  }
}

export const permissionGuard: CanActivateFn = (route, state) => {
  const permission = route.data['permission'] as RoutePermission | undefined;

  if (!permission) {
    return true;
  }

  const authService = inject(AuthService);
  const router = inject(Router);

  if (hasRoutePermission(authService, permission)) {
    return true;
  }

  return router.createUrlTree(['/403'], {
    queryParams: { from: state.url },
  });
};
